import React from 'react';
import {BuyButton} from './BuyButton';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {ReserveButton} from './ReserveButton';
import {SubscribeButton} from './SubscribeButton';
import styles from './style.module.scss';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';
import {plural} from 'core/helpers';

type TActionsProps = Pick<IProductSnippet, 'availability' | 'cart' | 'url'>;

export const CartActions = (props: TActionsProps) => {
    const {
        cart: {
            storesWithStockCount,
            reserveButtonText,
            isReservationFlowActive,
            onReserve,
            onSubscribe,
            onAddOne,
            onRemoveOne,
            onQuantityChange,
            onGoToCart,
            isPendingQuantityChange,
            quantity,
        },
        availability,
        url,
    } = props;

    const winestoresText = plural(storesWithStockCount, ['винотеке', 'винотеках', 'винотеках']);

    return (
        <div data-skeleton-item={''} className={styles.root}>
            {isReservationFlowActive && (
                <>
                    <div className={styles.overlayPlaceholder} />
                    <div className={styles.winestoreCouter}>
                        <Icon icon={'Express'} className={styles.expressIcon} />
                        <Typography variant={'label-12-r'}>
                            Только в {storesWithStockCount} {winestoresText}
                        </Typography>
                    </div>
                </>
            )}

            {
                {
                    ['IN_STOCK']: (
                        <BuyButton
                            onAddOne={onAddOne}
                            onRemoveOne={onRemoveOne}
                            isPendingQuantityChange={isPendingQuantityChange}
                            onQuantityChange={onQuantityChange}
                            onGoToCart={onGoToCart}
                            quantity={quantity}
                        />
                    ),
                    ['FOR_RESERVATION']: <ReserveButton onReserve={onReserve} url={url} text={reserveButtonText} />,
                    ['OUT_OF_STOCK']: <SubscribeButton onSubscribe={onSubscribe} url={url} />,
                }[availability]
            }
        </div>
    );
};
